import { Colors } from 'basic-ui-lib/constants';
import styled from 'styled-components';
import { Col, Text } from 'basic-ui-lib';
import { ColorPath } from 'basic-ui-lib/constants/colors';
export interface DashboardStatItemMobileProps {
  label?: string;
  value?: string | number;
  icon?: React.ReactNode;
  backgroundColorIcon?: string;
  colorValue?: ColorPath;
}

const DashboardStatItemMobile = ({ label, value, icon, colorValue }: DashboardStatItemMobileProps) => {
  return (
    <Container>
      {icon}
      <Col gap={0}>
        <Text caption_3 medium color='neutral.text.3' left>
          {label}
        </Text>
        <Text title_h9 semibold color={colorValue} left>
          {value}
        </Text>
      </Col>
    </Container>
  );
};

export default DashboardStatItemMobile;

const Container = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${Colors.neutral.bg[2]};
  background: ${Colors.neutral.bg[1]};
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.1);
`;
